import { createContext } from 'react';
import userInitialState from './utils/userInitialState';

const authContext = createContext({
  token: localStorage.getItem('blue_token'),
  showModal: false,
  closeSessionModal: () => {
  },
  isAuthenticated: false,
  loading: false,
  confirmPinRequired: false,
  user: userInitialState,
  error: '',
  euPortabilityStatusPopup: '',
  euPortabilityStatusPopupText: '',
  firstLogin: false,
  userLocation: '',
  loginWithToken: (data: { token: string }) => {
  },
  login: (data: { code?: string, state?: string, redirect_uri?: string, pin?: string,deleteSession?:boolean }) => {
  },
  logout: () => {
  },
  clearErrors: () => {
  },
  loadUser: () => {
  },
  updateUser: (data: { balance: number }) => {
  },
  setUserLocation: (data: { userLocation: string }) => {
  },
});

export default authContext;
